import React from 'react';
import "./style.css";
const Form =props=>{
    return(
        <div className="container">
            <div>{props.error?error():null}</div>
            <form onSubmit={props.loadweather}>
            <div className="row mt-5">
                <div className="col-md-3 offset-md-2 pt-2">
                    <input type="text"
                        className="form-control"
                        name="city"
                        autoComplete="off"
                        placeholder="City"
                    />
                </div>
                <div className="col-md-3 pt-2">
                    <input type="text"
                        className="form-control"
                        name="country"
                        autoComplete="off"
                        placeholder="Country"
                    />
                </div>
                <div className="col-md-3 mt-md-0 py-2 text-md-left">
                    <button className="btn btn-warning">Get Weather</button>
                </div>
            </div>
            </form>
        </div>
    );
};
function error(){
    return (
        // <div className="alert alert-danger mx-5" role="alert">
        //     Plese enter correct City and Country name
            
        // </div>
        <script>
            {alert("Please enter correct city and country name")}
        </script> 
        );
} 
export default Form;